export default __webpack_public_path__ + "static/media/Analog Smoke Detector.fe5d6000.pdf";